var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"transition-all",class:{
    'overflow-hidden': _vm.$route.path === '/bot/mail/reply',
    'fill-page': _vm.fillPageRoutes.includes(_vm.$route.path),
  },attrs:{"id":"app"}},[_c('router-view'),_c('PackageLimitDialog'),_c('PackageExpiredDialog'),_c('PackageLockedDialog'),_c('WhatsAppBalanceInsufficientDialog')],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }